// Shared Polish labels for discrepancy reason values stored by the API.
export const DISCREPANCY_REASON_OPTIONS = [
  { value: "", label: "Brak" },
  { value: "damage", label: "Uszkodzenie" },
  { value: "shortage", label: "Brak ilości" },
  { value: "wrong_item", label: "Zły towar" },
  { value: "wrong_qty", label: "Zła ilość" },
  { value: "packaging_issue", label: "Problem z opakowaniem" },
  { value: "other", label: "Inne" },
] as const

const discrepancyReasonLabels = new Map<string, string>(
  DISCREPANCY_REASON_OPTIONS.map((option) => [option.value, option.label]),
)

/** Returns the operator-facing Polish label for an API discrepancy reason. */
export function getDiscrepancyReasonLabel(value?: string | null) {
  const normalizedValue = value?.trim().toLowerCase() ?? ""
  if (!normalizedValue) return "—"
  return discrepancyReasonLabels.get(normalizedValue) ?? "Inne"
}
